export default {
  /* KNB Error Code List */
  INTERNAL_ERROR: {
    errorCode: -1,
    errorMsg: 'internal error'
  },
  PERMISSION_DENIED: {
    errorCode: -100,
    errorMsg: 'app require device auth'
  },
  PARAMS_LACK: {
    errorCode: -400,
    errorMsg: 'require parameters'
  },
  PARAMS_ERROR: {
    errorCode: -401,
    errorMsg: 'pamameter error'
  },
  AUTH_ERROR: {
    errorCode: -403,
    errorMsg: 'document require app auth'
  },
  NO_API: {
    errorCode: -404,
    errorMsg: 'method not found'
  },
  METHOD_ERROR: {
    errorCode: -500,
    errorMsg: 'method error'
  },
  NOT_IMPLEMENTED: {
    errorCode: -504,
    errorMsg: 'method not implemented'
  },

  /* Our Error Code List */
  NO_SDK: {
    errorCode: -10001,
    errorMsg: 'no sdk loaded'
  },
  NOT_READY: {
    errorCode: -10002,
    errorMsg: 'bridge not ready'
  },
  USER_CANCEL: {
    errorCode: -10003,
    errorMsg: 'user call cancel'
  }
};
